import {Text} from "@chakra-ui/react";
import React, {MutableRefObject, useEffect, useState} from 'react'

import {useFont} from "../hooks/FontProvider";

type TimerProps = {
  timeLeft: MutableRefObject<number>;
  onTimerFinished?: (seconds: number) => void;
};

type TimeObj = {
  hours?: number;
  seconds?: number;
  minutes?: number;
};

// TODO: fix-> timerInterval continues after the test is completed
// solution: move timerInterval to Test.tsx
// right now it doesnt affect because updateTime doesnt save if test is complete

// TimerComponent rerenders every time the user answer a question
// to prevent memory leaks, the interval must be stopped and restared every time
// currentTime must be a useState for the on screen text to be updated
// the timerInterval id is used globally, when the component rerenders
//    the interval is reset and assigned to currentTime
let timerInterval = 0;

const TimerComponent  = ( props : TimerProps ) => {
  const font = useFont().font;
  const originalPath = window.location.pathname;
  let seconds = props.timeLeft.current;
  const [currentTime, setCurrentTime] = useState<TimeObj>(secondsToTime(seconds));

  function secondsToTime(secs:number) {
    const hours = Math.floor(secs / (60 * 60));

    const divisor_for_minutes = secs % (60 * 60);
    const minutes = Math.floor(divisor_for_minutes / 60);

    const divisor_for_seconds = divisor_for_minutes % 60;
    const seconds = Math.ceil(divisor_for_seconds);

    return {hours:hours,seconds:seconds,minutes:minutes};
  }
  function timeToSeconds(time:TimeObj) {
    const hours = Math.floor(time.hours? time.hours * (60 * 60) : 0);
    const minutes = Math.floor(time.minutes? time.minutes * 60 : 0);
    const seconds = Math.ceil(time.seconds? time.seconds : 0);

    return hours+minutes+seconds;
  }

  function startTimer() {
    if (seconds > 0) {
      setCurrentTime(secondsToTime(seconds));
      if (timerInterval === 0) {
        timerInterval = (window.setInterval(countDown, 1000));
      } else {
        window.clearInterval(timerInterval);
        timerInterval = (window.setInterval(countDown, 1000));
      }
    }
  }

  function saveTime() {
    window.clearInterval(timerInterval);
    if (props.onTimerFinished) props.onTimerFinished(props.timeLeft.current);
  }

  function countDown() {
    //  console.log(props.stopTimer)
    //if (props.stopTimer && timerInterval) window.clearInterval(timerInterval);
    //  console.log(seconds)

    // if the user goes back to previous page
    if (window.location.pathname !== originalPath) {
      saveTime();
      return;
    }
    if ( !document.hasFocus() ) return;
    seconds = (seconds - 1);
    props.timeLeft.current = seconds;
    setCurrentTime(secondsToTime(seconds));

    if (seconds === 0) {
      saveTime();
    }
  }

  // start timer on initial render
  useEffect(() => {
    startTimer();
  }, []);

  window.onbeforeunload = () => {
    if (timerInterval !== 0) {
      saveTime();
    }
  };

  function addPadding(n:number | undefined) {
    return ('00'+n).slice(-2);
  }

  return (
      <Text marginBottom="-25px" marginRight="10px" position="relative" float="right"
            marginLeft="-500px" marginTop="-10px"
            fontWeight={font.weight}
            fontSize={font.buttonText}
      >Time left: {addPadding(currentTime.hours)}:{addPadding(currentTime.minutes)}:{addPadding(currentTime.seconds)}</Text>
  );
};

export default TimerComponent;